import { useState } from 'react';
import { Box, Checkbox } from '@mui/material';
import { axiosInstance } from 'api/axios';
import LOGO from 'assets/images/nautiqus-logo.jpg';
import { useAuth } from 'contexts/authContext';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { reactPaths } from 'root/pathnames';
import * as S from './LoginScreen.css';

interface AcceptancesData {
  acceptedPrivacyPolicy: boolean;
  acceptedProcessingPersonalData: boolean;
}

export const Acceptances = () => {
  const { checkAuth } = useAuth();
  const navigate = useNavigate();

  const [showInfo, setShowInfo] = useState(false);
  const [acceptancesData, setAcceptancesData] = useState<AcceptancesData>({
    acceptedPrivacyPolicy: false,
    acceptedProcessingPersonalData: false,
  });

  const { t } = useTranslation(['button']);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    await axiosInstance
      .put('/context/updateAcceptances', acceptancesData)
      .then((_) => {
        checkAuth({
          successCallback: () => navigate(reactPaths.home, { replace: true }),
        });
      });
  };

  return (
    <Box
      sx={{
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        flex: 1,
        px: 2,
        pb: 4,
        mt: -4,
      }}
    >
      <S.LogoContainer>
        <img src={LOGO} alt='logo' />
      </S.LogoContainer>
      <S.Title>{t('acceptances', { ns: 'login' })}</S.Title>
      <form onSubmit={handleSubmit}>
        <S.Acceptances>
          <S.AcceptanceLine>
            <Checkbox
              id='acceptedPrivacyPolicy'
              checked={acceptancesData.acceptedPrivacyPolicy}
              onChange={() =>
                setAcceptancesData((prev) => ({
                  ...prev,
                  acceptedPrivacyPolicy: !prev.acceptedPrivacyPolicy,
                }))
              }
              required
              size='small'
              disableRipple
              style={{ width: 20, paddingRight: 20 }}
            />
            <p>
              Zapoznałem się i akceptuję{' '}
              <a href='https://www.nautiqus.pl/polityka-prywatnosci,166,pl.html'>
                Politykę Prywatności Nautiqus
              </a>
              .
            </p>
          </S.AcceptanceLine>
          <S.AcceptanceLine>
            <Checkbox
              id='acceptedProcessingPersonalData'
              checked={acceptancesData.acceptedProcessingPersonalData}
              onChange={() =>
                setAcceptancesData((prev) => ({
                  ...prev,
                  acceptedProcessingPersonalData:
                    !prev.acceptedProcessingPersonalData,
                }))
              }
              required
              size='small'
              disableRipple
              style={{ width: 20, paddingRight: 20 }}
            />
            <p>
              Wyrażam zgodę na przetwarzanie danych osobowych (imię, nazwisko,
              adres e-mail) przez Nautiqus Sp. z o.o. w celu umożliwienia
              dostępu do systemu STORM w ramach świadczonej usługi spedycyjnej
              oraz agencji celnej.
            </p>
          </S.AcceptanceLine>
          <S.DataInfoHeader onClick={() => setShowInfo((prev) => !prev)}>
            OBOWIĄZEK INFORMACYJNY...
          </S.DataInfoHeader>
          {showInfo && (
            <S.DataInfo>
              Nautiqus Sp. z o.o. zarejestrowaną w Krajowym Rejestrze Sądowym
              prowadzonym Sąd Rejonowy Gdańsk-Północ w Gdańsku, VIII Wydział
              Gospodarczy Krajowego Rejestru Sądowego, pod numerem KRS
              0000307697, kapitał zakładowy wpłacony w całości w wysokości 50
              000 PLN, NIP 9570998230; REGON 220627415, jako administrator
              danych osobowych, informuje Pania/Pana, iż:
              <ul>
                <li>
                  podanie danych osobowych jest dobrowolne, ich niepodanie
                  uniemożliwi dostęp do pełnych treści serwisu
                </li>
                <li>
                  dane przetwarzane będą w celu umożliwienia dostępu do pełnej
                  treści serwisu
                </li>
                <li>
                  dane nie są udostępniane przez Administratora podmiotom
                  trzecim
                </li>
                <li>
                  posiada Pan/Pani prawo dostępu do treści swoich danych i ich
                  sprostowania, usunięcia, ograniczenia przetwarzania, prawo do
                  przenoszenia danych, prawo do wniesienia sprzeciwu wobec
                  przetwarzania
                </li>
                <li>
                  ma Pan/Pani prawo wniesienia skargi do PUODO gdy uzna
                  Pan/Pani, iż przetwarzanie danych osobowych Pani/Pana
                  dotyczących narusza przepisy ogólnego rozporządzenia o
                  ochronie danych osobowych z dnia 27 kwietnia 2016 r
                </li>
              </ul>
            </S.DataInfo>
          )}
          <S.LoginButton type='submit'>
            {t('button.save', { ns: 'misc' })}
          </S.LoginButton>
        </S.Acceptances>
      </form>
    </Box>
  );
};
